/**
 * 用户登录相关
 */
 import store from './localStore'

 const UserKey = 'cd_auth_user'
 const UserIdKey = 'cd_auth_user_id'
 const TokenKey = 'cd_auth_token'

 export function isAuthenticated () {
   return !!store.getItem(UserKey)
 }

 export function getUserId () {
   return store.getItem(UserIdKey, false)
 }

 export function setUserId (userId) {
   store.setItem(UserIdKey, userId)
 }

 export function setUser (user) {
   store.setItem(UserKey, user)
 }

 export function getUser () {
   return store.getItem(UserKey)
 }

 export function getToken () {
   return store.getItem(TokenKey, false)
 }

 export function setToken (token) {
   store.setItem(TokenKey, token)
 }

 export function clearAuth () {
   store.removeItem(UserKey)
   store.removeItem(TokenKey)
   store.removeItem(UserIdKey)
 }
